// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

/**
 * Fluent's default buttons are not friendly to touch users.
 * This the height recommended for touch targets.
 */
export const MOBILE_BUTTON_HEIGHT_REM = 3;
